import React from "react";

const sectionStyle = {
  marginBottom: "28px",
};

const h1Style = {
  fontSize: "2.2rem",
  fontWeight: 700,
  marginBottom: "12px",
  color: "#111111",
};

const h2Style = {
  fontSize: "1.2rem",
  fontWeight: 700,
  marginBottom: "10px",
  color: "#111111",
};

const pStyle = {
  fontSize: "1rem",
  lineHeight: 1.75,
  color: "#333333",
  marginBottom: "10px",
};

const liStyle = {
  fontSize: "1rem",
  lineHeight: 1.75,
  color: "#333333",
  marginBottom: "8px",
};

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        background: "#ffffff",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <div
        style={{
          maxWidth: "960px",
          margin: "0 auto",
          padding: "48px 20px 80px",
        }}
      >
        <div style={{ marginBottom: "32px" }}>
          <h1 style={h1Style}>Privacy Policy</h1>
          <p style={pStyle}>
            <strong>Wayroot Technologies Private Limited</strong>
          </p>
          <p style={pStyle}>
            Effective Date: 21 March 2026
          </p>
          <p style={pStyle}>
            This Privacy Policy explains how Wayroot Technologies Private Limited
            ("Wayroot", "we", "our", or "us") collects, uses, stores, shares,
            and protects personal information when you use the Wayroot platform,
            including our website, mobile applications, and related services.
          </p>
          <p style={pStyle}>
            This policy currently applies to users interacting with Wayroot for
            onboarding, profile creation, vehicle owner onboarding, driver
            onboarding, support, and related mobility platform services.
          </p>
        </div>

        <section style={sectionStyle}>
          <h2 style={h2Style}>1. Information We Collect</h2>
          <p style={pStyle}>
            We may collect the following categories of information depending on
            how you use Wayroot:
          </p>
          <ul style={{ paddingLeft: "22px" }}>
            <li style={liStyle}>
              <strong>Profile and contact information</strong>, such as your
              name, phone number, email address, city, and account details.
            </li>
            <li style={liStyle}>
              <strong>Identity and verification information</strong>, such as
              government identification details, driving licence details,
              vehicle registration details, insurance details, and other
              verification-related information you submit.
            </li>
            <li style={liStyle}>
              <strong>Vehicle and onboarding information</strong>, such as
              vehicle type, model, registration number, seating capacity, fuel
              type, ownership details, compliance details, and uploaded vehicle
              photos or documents.
            </li>
            <li style={liStyle}>
              <strong>Uploaded files and documents</strong>, including images,
              PDFs, and other files submitted during onboarding, verification,
              support, or compliance processes.
            </li>
            <li style={liStyle}>
              <strong>Location information</strong>, including approximate or
              precise location information when you grant permission and when
              location is necessary for app functionality, such as mapping,
              discovery, route visibility, support, or operational features.
            </li>
            <li style={liStyle}>
              <strong>Device and technical information</strong>, such as device
              model, operating system, app version, IP address, crash data,
              diagnostic data, and usage logs.
            </li>
            <li style={liStyle}>
              <strong>Communication and support information</strong>, including
              your messages, support requests, feedback, and communications with
              Wayroot.
            </li>
            <li style={liStyle}>
              <strong>Transaction-related information</strong>, where applicable,
              including booking-related metadata, payout-related information, or
              payment processing status. For this phase, some payment-related
              features may be limited, unavailable, or introduced in later
              updates.
            </li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>2. How We Collect Information</h2>
          <p style={pStyle}>We collect information in the following ways:</p>
          <ul style={{ paddingLeft: "22px" }}>
            <li style={liStyle}>Directly from you when you register, log in, fill forms, upload documents, or contact us.</li>
            <li style={liStyle}>Automatically through your use of the app or website, including technical logs and device information.</li>
            <li style={liStyle}>From permissions you grant, such as camera, storage, notifications, or location permissions.</li>
            <li style={liStyle}>From service providers, verification partners, mapping services, cloud storage providers, analytics or infrastructure partners, where applicable.</li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>3. Why We Use Your Information</h2>
          <p style={pStyle}>We use your information for purposes including:</p>
          <ul style={{ paddingLeft: "22px" }}>
            <li style={liStyle}>Creating and managing your account.</li>
            <li style={liStyle}>Completing owner, driver, or vehicle onboarding.</li>
            <li style={liStyle}>Reviewing and verifying submitted documents and compliance information.</li>
            <li style={liStyle}>Providing app features, platform access, and operational support.</li>
            <li style={liStyle}>Showing maps, routes, visibility areas, and related mobility platform functionality.</li>
            <li style={liStyle}>Improving safety, fraud prevention, and platform integrity.</li>
            <li style={liStyle}>Troubleshooting bugs, crashes, and technical issues.</li>
            <li style={liStyle}>Communicating with you about updates, onboarding status, support, service information, or policy changes.</li>
            <li style={liStyle}>Complying with legal, tax, audit, regulatory, or law-enforcement requirements.</li>
            <li style={liStyle}>Enabling future service features, including bookings, support processes, and platform operations, where applicable.</li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>4. Permissions We May Request</h2>
          <p style={pStyle}>Depending on your device and the features you use, the Wayroot app may request access to:</p>
          <ul style={{ paddingLeft: "22px" }}>
            <li style={liStyle}><strong>Camera</strong> for capturing profile images, documents, vehicle photos, or verification uploads.</li>
            <li style={liStyle}><strong>Photos / Media / Storage</strong> for selecting and uploading files, photos, or documents.</li>
            <li style={liStyle}><strong>Location</strong> for map features, location-based discovery, support, operational workflows, and route-related functionality.</li>
            <li style={liStyle}><strong>Notifications</strong> for alerts, onboarding updates, assignments, support communication, or service messages.</li>
          </ul>
          <p style={pStyle}>
            You can manage device permissions through your phone settings, but
            disabling some permissions may affect app functionality.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>5. How We Share Information</h2>
          <p style={pStyle}>We do not sell your personal information. We may share information only in limited circumstances such as:</p>
          <ul style={{ paddingLeft: "22px" }}>
            <li style={liStyle}>With service providers and infrastructure partners who help us operate the platform, such as hosting, cloud storage, notifications, analytics, mapping, or support tools.</li>
            <li style={liStyle}>With verification, compliance, support, legal, financial, or operational partners where necessary to process onboarding, investigate issues, or meet legal requirements.</li>
            <li style={liStyle}>With government authorities, regulators, law enforcement, courts, or other parties when required by law or to protect rights, safety, and platform integrity.</li>
            <li style={liStyle}>As part of a business transfer, restructuring, merger, acquisition, or similar corporate event, subject to applicable safeguards.</li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>6. Data Retention</h2>
          <p style={pStyle}>
            We retain information for as long as necessary to provide our
            services, complete onboarding, maintain business and legal records,
            resolve disputes, enforce agreements, prevent fraud, and comply with
            legal or regulatory obligations.
          </p>
          <p style={pStyle}>
            Retention periods may vary depending on the type of data, account
            status, compliance requirements, and operational necessity.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>7. Data Security</h2>
          <p style={pStyle}>
            We use reasonable technical, administrative, and organizational
            safeguards to protect personal information from unauthorized access,
            misuse, loss, alteration, or disclosure. However, no system can be
            guaranteed to be completely secure, and you use the platform at your
            own risk.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>8. Your Choices and Rights</h2>
          <p style={pStyle}>Subject to applicable law, you may have the ability to:</p>
          <ul style={{ paddingLeft: "22px" }}>
            <li style={liStyle}>Access or review certain account information.</li>
            <li style={liStyle}>Request correction of inaccurate information.</li>
            <li style={liStyle}>Request deletion of your account or certain personal information, subject to legal and operational retention requirements.</li>
            <li style={liStyle}>Withdraw certain permissions through device settings.</li>
            <li style={liStyle}>Contact us regarding privacy-related concerns or requests.</li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>9. Children’s Privacy</h2>
          <p style={pStyle}>
            Wayroot is not intended for children. We do not knowingly collect
            personal information from children in violation of applicable law.
            If you believe a child has submitted personal information to us,
            please contact us so we can review and take appropriate action.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>10. Third-Party Services</h2>
          <p style={pStyle}>
            Our platform may rely on third-party services such as mapping,
            cloud hosting, analytics, document storage, OTP, notifications, or
            payment-related providers. Their handling of data may be governed by
            their own privacy policies and terms, where applicable.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>11. Changes to This Privacy Policy</h2>
          <p style={pStyle}>
            We may update this Privacy Policy from time to time. We will post
            the revised version with an updated effective date. Continued use of
            the platform after changes become effective means you accept the
            updated policy, to the extent permitted by law.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>12. Contact Us</h2>
          <p style={pStyle}>
            If you have questions, requests, or concerns about this Privacy
            Policy or your personal information, please contact:
          </p>
          <p style={pStyle}>
            <strong>Wayroot Technologies Private Limited</strong>
            <br />
            Email: support@wayroot.com
            <br />
            Website: https://wayroot.com
            <br />
            Address: [Wayroot Technologies Private Limited, Jarang, Muzaffarpur, Bihar, India, 843118]
          </p>
        </section>
      </div>
    </div>
  );
}